import { __assign } from "tslib";
import { compose } from 'redux';
import { connect } from 'react-redux';
import HandoffDefault from '../../components/handoff/HandoffDefault';
import { hideHandoff } from '../../actionCreators';
import { isWeb } from '../../selectors/project';
import getCanvasFonts from '../../utils/handoff/getCanvasFonts';
import { getArtboard, getHandoffState, isHandoffAvailable, } from '../../selectors/handoff';
function mapStateToProps(state) {
    var props;
    if (!isHandoffAvailable(state)) {
        props = {
            screenHasHandoffData: false,
        };
    }
    else if (state.handoff.canvas) {
        props = {
            isWeb: isWeb(state),
            screenHasHandoffData: true,
            artboard: getArtboard(state),
            fonts: getCanvasFonts(state.handoff.flatCanvas),
        };
    }
    else {
        props = {
            screenHasHandoffData: true,
        };
    }
    return __assign({ handoffState: getHandoffState(state), requestStatus: state.handoff.requestStatus }, props);
}
function mapDispatchToProps(dispatch) {
    return {
        onClose: function () {
            dispatch(hideHandoff());
        },
    };
}
export default compose(connect(mapStateToProps, mapDispatchToProps))(HandoffDefault);
